import ContactContent from "./ContactContent";

export default ContactContent;